import { render, staticRenderFns } from "./app-header.vue?vue&type=template&id=b73f842c&scoped=true"
import script from "./app-header.vue?vue&type=script&lang=ts"
export * from "./app-header.vue?vue&type=script&lang=ts"
import style0 from "./app-header.vue?vue&type=style&index=0&id=b73f842c&prod&lang=scss&scoped=true"
import style1 from "./app-header.vue?vue&type=style&index=1&id=b73f842c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73f842c",
  null
  
)

export default component.exports